import type WorkflowStepDefinitionModel from '@src/service/model/workflow/WorkflowStepDefinitionModel'

import Repository from './base'

export const WORKFLOW_STEP_DEFINITION_TABLE_NAME = 'workflowStepDefinition'
export class WorkflowStepDefinitionRepository extends Repository<WorkflowStepDefinitionModel> {}
